// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Typo-medium-71cd{font-weight:500}.Typo-semi-71cd{font-weight:600}.Typo-bold-71cd{font-weight:700}.Typo-mono-71cd{font-family:var(--ui-font-family-monospace),monospace}.Typo-center-71cd{text-align:center}.Typo-ellipsis-71cd{display:block;flex-shrink:1;min-width:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.Typo-one-71cd{line-height:1}.Typo-nowrap-71cd{white-space:nowrap}.Typo-wrap-71cd{white-space:wrap;word-wrap:anywhere}.Typo-balance-71cd{white-space:wrap;text-wrap:balance;word-wrap:anywhere}.Typo-upper-71cd{text-transform:uppercase}.Typo-code-71cd{white-space:pre}.Typo-pre-71cd{white-space:pre-wrap}.Typo-primary-71cd{color:var(--ui-primary-color)}.Typo-first-71cd{color:var(--ui-text-color)}.Typo-secondary-71cd{color:var(--ui-text-color-secondary)}.Typo-tertiary-71cd{color:var(--ui-text-color-tertiary)}.Typo-error-71cd{color:var(--ui-text-color-error)}`, "",{"version":3,"sources":["webpack://./src/component/Typo/Typo.module.scss"],"names":[],"mappings":"AAAA,kBACE,eAAA,CAGF,gBACE,eAAA,CAGF,gBACE,eAAA,CAGF,gBACE,qDAAA,CAGF,kBACE,iBAAA,CAGF,oBACE,aAAA,CACA,aAAA,CACA,WAAA,CACA,eAAA,CACA,kBAAA,CACA,sBAAA,CAGF,eACE,aAAA,CAGF,kBACE,kBAAA,CAGF,gBACE,gBAAA,CACA,kBAAA,CAGF,mBACE,gBAAA,CACA,iBAAA,CACA,kBAAA,CAGF,iBACE,wBAAA,CAGF,gBACE,eAAA,CAGF,eACE,oBAAA,CAGF,mBACE,6BAAA,CAGF,iBACE,0BAAA,CAGF,qBACE,oCAAA,CAGF,oBACE,mCAAA,CAGF,iBACE,gCAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"medium": `Typo-medium-71cd`,
	"semi": `Typo-semi-71cd`,
	"bold": `Typo-bold-71cd`,
	"mono": `Typo-mono-71cd`,
	"center": `Typo-center-71cd`,
	"ellipsis": `Typo-ellipsis-71cd`,
	"one": `Typo-one-71cd`,
	"nowrap": `Typo-nowrap-71cd`,
	"wrap": `Typo-wrap-71cd`,
	"balance": `Typo-balance-71cd`,
	"upper": `Typo-upper-71cd`,
	"code": `Typo-code-71cd`,
	"pre": `Typo-pre-71cd`,
	"primary": `Typo-primary-71cd`,
	"first": `Typo-first-71cd`,
	"secondary": `Typo-secondary-71cd`,
	"tertiary": `Typo-tertiary-71cd`,
	"error": `Typo-error-71cd`
};
module.exports = ___CSS_LOADER_EXPORT___;
